/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Brand-sum': {
    width: 22,
    height: 17,
    viewBox: '0 0 22 17',
    data: '<path pid="0" d="M5.583 16.584h10.834V.334H5.583v16.25zM.167 14.417H4.5V2.5H.167v11.917zM17.5 2.5v11.917h4.333V2.5H17.5z" _fill="#9BC225"/>'
  }
})
